import React from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {LOWES_DISCLAIMER_EN} from "../../misc/fabricatorHardcode";

const DepositDisclaimer = (props) => {

  const {intl, fabricatorData} = props;

  const getDisclaimerMessage = () => {
    if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.messages) {
      if (intl.locale === "fr-FR" && intl.messages["transDoc.description_FR._disclaimer"]) {
        return intl.messages["transDoc.description_FR._disclaimer"]
      } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customTranslateDescription_PL._disclaimer"]) {
        return intl.messages["transDoc.customTranslateDescription_PL._disclaimer"]
      } else if (fabricatorData.isLowes) {
        return LOWES_DISCLAIMER_EN
      }
    }
    return fabricatorData.settings.depositDisclaimer
  }

  return (
    <div className="disclaimer">
      <span className="disclaimer-icon"/>
      <div className="disclaimer-message" dangerouslySetInnerHTML={{__html: getDisclaimerMessage()}}/>
    </div>
  );
};

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DepositDisclaimer)
)
